export default __webpack_public_path__ + "static/media/dep2_6.d9ba2249.png";